module.exports = {"ja":"日本語","en":"English"}


//////////////////
// WEBPACK FOOTER
// ./src/Lang.json
// module id = 1563
// module chunks = 0